export const ACategoryOptions = [
    { value: '1', label: 'Movité věci' },
    { value: '2', label: 'Nemovitosti' },
    { value: '3', label: 'Ostatní' }
];
export const getCategoryLabel = (value) => {
    let res = ACategoryOptions.filter(obj => obj.value == value)[0];
    return res ? res.label : 'N/A';
};
